import { createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getUsageEstimate, recordOfferUsageSpecified } from '../services/UsageEstimatePublicService';

export const useUsageEstimatePublicGetUsageEstimate = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(getUsageEstimate, 'requestBody', 'data'),
      'data',
      'residents',
      'buildingType',
      'buildingAge',
      'energyType',
    ),
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['residents', 'buildingType', 'buildingAge', 'energyType'] },
    ],
  },
);

export const useUsageEstimatePublicRecordOfferUsageSpecified = createMutationHook(
  collapseParams(
    collapseParams(recordOfferUsageSpecified, 'requestBody', 'data'),
    'data',
    'gbVariant',
    'postalCode',
    'houseNumber',
    'houseNumberSuffix',
    'energyType',
    'usageSource',
    'residents',
    'buildingType',
    'buildingAge',
    'hasDoubleMeter',
    'electricityUsagePeak',
    'electricityUsageOffPeak',
    'electricityRedelivery',
    'gasUsage',
    'warmthUsage',
    'tapWaterUsage',
  ),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: false,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      {
        target: 'data',
        props: [
          'gbVariant',
          'postalCode',
          'houseNumber',
          'houseNumberSuffix',
          'energyType',
          'usageSource',
          'residents',
          'buildingType',
          'buildingAge',
          'hasDoubleMeter',
          'electricityUsagePeak',
          'electricityUsageOffPeak',
          'electricityRedelivery',
          'gasUsage',
          'warmthUsage',
          'tapWaterUsage',
        ],
      },
    ],
  },
);
